module.exports = __webpack_public_path__ + "static/img/phone.4621c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = 66
// module chunks = 0